import {jwtDecode} from "jwt-decode";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setState } from "../store/loginSlice";

const useTokenValidation = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    // debugger;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    if (!token) {
        dispatch(setState("isLoggedIn", false));
        // dispatch(setState("globalSelectedCountryName", ""));
        // dispatch(setState("globalSelectedCountryID", ""));       
        localStorage.removeItem("data");
        localStorage.clear();
        sessionStorage.clear();        
      navigate("/mslogin");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        dispatch(setState("isLoggedIn", false));
        // dispatch(setState("globalSelectedCountryName", ""));
        // dispatch(setState("globalSelectedCountryID", ""));       
        localStorage.removeItem("data");
        localStorage.clear();
        sessionStorage.clear();
        navigate("/mslogin");
      }
    } catch (error) {
      console.error("Token validation error:", error);
      dispatch(setState("isLoggedIn", false));
      // dispatch(setState("globalSelectedCountryName", ""));
      // dispatch(setState("globalSelectedCountryID", ""));       
      localStorage.removeItem("data");
      localStorage.clear();
      sessionStorage.clear();
      navigate("/mslogin");
    }
  }, [navigate]);
};

export default useTokenValidation;